<template>
    <Layout>
        <PageHeader :title="title" />
        <div class="withdraw-wrapper">
            <WithdrawRequest @withdrawRequest="withdrawRequest" :isLoading="isLoading" :hasPendingWithdraw="hasPendingWithdraw" :withdrawData="withdrawData" :isRequestLoading="isRequestLoading"/>

            <div class="withdraw-list-wrapper" v-if="!isListLoading">
                <div v-if="!withdrawList" class="card noresult">
                    <div class="text-center">
                        <lottie
                            class="avatar-xl"
                            colors="primary:#121331,secondary:#08a88a"
                            :options="defaultOptions"
                            :height="75"
                            :width="75"
                        />
                        <h5 class="mt-2">درخواست برداشتی یافت نشد.</h5>
                    </div>
                </div>

                <div v-else class="withdraw-list">
                    <div v-for="(withdraw, index) in withdrawList" :key="index" class="withdraw-item" :class="withdraw.status">
                        <div class="col-sm-6 col-lg-4 col-6">
                            <div class="details">
                                <div class="withdraw-number">
                                    <div class="number">#{{withdraw.id}}</div>
                                    <div class="status-label">{{withdraw.status_label}}</div>
                                </div>
                                <div class="withdraw-date">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                                    <span>تاریخ</span>
                                    <span class="date">
                    {{withdraw.jalali_insert_date}}
                  </span>
                                </div>
                                <div class="withdraw-update">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-clock"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                                    <span>تاریخ بروزرسانی</span>
                                    <span class="date">
                    {{withdraw.jalali_update_date}}
                  </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-6 ">
                            <div class="withdraw-item-description" v-if="withdraw.description.length">
                                <span>توضیحات:</span>
                                <span>
                  {{withdraw.description}}
                </span>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-6 ">
                            <div class="withdraw-amount-wrapper">
                                <div class="withdraw-amount" v-if="!withdraw.gold_amount" v-html="withdraw.amount_html"></div>
                                <div class="withdraw-gold-amount" v-else>
                                    {{withdraw.gold_amount}} گرم طلا
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-3">
                    <div class="pagination-wrap hstack gap-2">
                        <a
                            class="page-item pagination-prev disabled"
                            href="#"
                            v-if="page != 1"
                            @click="page--;  fetchWithdrawList()"
                        >
                            قبلی
                        </a>
                        <ul class="pagination listjs-pagination mb-0">
                            <li
                                v-for="(pageNumber, index) in pages.slice(
                          page - 1,
                          page + 5
                        )"
                                :key="index"
                                @click="page = pageNumber;  fetchWithdrawList()"
                                :class="{
                                active: pageNumber == page,
                                disabled: pageNumber == '...',
                              }"
                            >
                                <a class="page" href="#">{{ pageNumber }}</a>
                            </li>
                        </ul>
                        <a class="page-item pagination-next" href="#" @click="page++; fetchWithdrawList()" v-if="page < pages.length">
                            بعدی
                        </a>
                    </div>
                </div>
            </div>
            <div v-else class="withdraw-list-wrapper">
                <div class="withdraw-list">
                    <div v-for="index in 4" :key="index" class="withdraw-item">
                        <div class="col-sm-6 col-lg-4 col-6">
                            <div class="details">
                                <div class="withdraw-number">
                                    <Skeletor style="width: 100px;" />
                                </div>
                                <div class="withdraw-date">
                                    <Skeletor style="width: 100px;" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-6 ">
                            <div class="withdraw-item-description">
                                <Skeletor style="width: 100px;" />
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 col-6 ">
                            <Skeletor style="width: 100px;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";
import PageHeader from "@/components/page-header";
import WithdrawRequest from "./withdraw-request";
import UserService from "@/services/user.service";
import { Skeletor } from "vue-skeletor";
import Lottie from "@/components/widgets/lottie";
import animationData from "@/components/widgets/msoeawqm.json";

export default {
    name: "withdraw.vue",
    data() {
        return {
            title: "درخواست برداشت",
            isLoading: true,
            isRequestLoading: false,
            isListLoading: true,
            withdrawData: '',
            withdrawList: '',
            withdrawTotalCount: '',
            page: 1,
            perPage: 10,
            pages: [],
            hasPendingWithdraw: '',
            defaultOptions: { animationData: animationData },
        };
    },
    page: {
        title: "درخواست برداشت",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        WithdrawRequest,
        Skeletor,
        Lottie
    },
    created() {
        this.fetchPromises();
    },
    watch: {
        withdrawList() {
            this.setPages();
        },
    },
    methods: {
        withdrawRequest($type) {
            this.isRequestLoading = true;
            return new Promise((resolve) => {
                this.profileIsUpdating = true;
                UserService.vendorWithdrawRequest($type)
                    .then((response) => {
                        resolve(response);
                        this.$notify({
                            title: response.data.message,
                            type: 'success',
                        });
                        this.page = 1;
                        this.fetchWithdrawList();
                        this.fetchWithdrawData();
                    }, (error) => {
                        this.$notify({
                            title: "خطا",
                            text: error.message,
                            type: 'error',
                        });
                    })
                    .then(() => {
                        this.isLoading = false;
                        this.isRequestLoading = false;
                    });
            });
        },
        fetchWithdrawData() {
            this.isLoading = true;
            return UserService.getWithdrawData()
                .then((response) => {
                  console.log(response)

                  const {data} = response;
                    this.withdrawData = data;
                    this.isLoading = false;
                    if(response.status === 204) {
                        this.hasPendingWithdraw = true;
                    }
                });
        },
        fetchWithdrawList() {
            this.isListLoading = true;
            return UserService.getWithdrawList()
                .then((response) => {
                    if(response.status === 204) {
                        this.isListLoading = false;
                    } else {
                        const {data} = response;
                        this.withdrawTotalCount = data.total;
                        this.withdrawList = data.list;
                        this.isListLoading = false;
                    }
                });
        },
        fetchPromises() {
            this.isTransactionsLoading = true;
            Promise.all([
                this.fetchWithdrawList(),
                this.fetchWithdrawData(),
            ])
        },

        setPages() {
            this.pages = [];
            let numberOfPages = Math.ceil(this.withdrawTotalCount / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },
        paginate(transactions) {
            let page = this.page;
            let perPage = this.perPage;
            let from = page * perPage - perPage;
            let to = page * perPage;
            return transactions.slice(from, to);
        },
        SearchData() {
            this.resultQuery;
        },
    }
}
</script>

<style scoped>

</style>
